import { ref, type Reactive, type Ref } from 'vue';
import { useReactiveMasters } from 'src/composables/useMasters';
import type { IExtremeMapRef, IMovieMetaInfoArea, IMoviePlayerControlArea } from 'src/models';
import type { MastersContext } from 'src/models/master';

export interface MoviePlayerCommonRefsContext {
  refExtremeMap: Ref<IExtremeMapRef | undefined>;
  refTopBarArea: Ref<HTMLDivElement | undefined>;
  refVideoArea: Ref<HTMLDivElement | undefined>;
  refControlArea: Ref<IMoviePlayerControlArea | undefined>;
  refMetaInfoArea: Ref<IMovieMetaInfoArea | undefined>;
  masters: Reactive<MastersContext>;
  resolveMastersPromise: () => Promise<void>;
}

// BasicMoviePlayerのref・masters取得。
// 動画要素のref（refMoviePlayerVideos等）は呼び出し側で個別に用意する。
export function useMoviePlayerCommonRefs(): MoviePlayerCommonRefsContext {
  const refExtremeMap = ref<IExtremeMapRef>();
  const refTopBarArea = ref<HTMLDivElement>();
  const refVideoArea = ref<HTMLDivElement>();
  const refControlArea = ref<IMoviePlayerControlArea>();
  const refMetaInfoArea = ref<IMovieMetaInfoArea>();
  const { masters, resolveMastersPromise } = useReactiveMasters();

  return {
    refExtremeMap,
    refTopBarArea,
    refVideoArea,
    refControlArea,
    refMetaInfoArea,
    masters,
    resolveMastersPromise,
  };
}
